import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useSelectedBatteries = (): string[] => {
  const [searchParameters] = useSearchParams();
  return useMemo(() => searchParameters.getAll('battery'), [searchParameters]);
};

export default useSelectedBatteries;
